export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सफलता"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["त्रुटि"])}
}